module.exports = __webpack_public_path__ + "img/jbtjk02.e69bd365.png";